<template>
  <!-- Filtro Categoría -->
  <v-menu bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-chip
        @click:close="removeCategoria"
        :close="selectedCategoria"
        class="ma-2"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        Categoría
        <span v-if="selectedCategoria">: {{ selectedCategoria }}</span>
      </v-chip>
    </template>
    <v-card>
      <producto-filtro-categoria type="list" @select-categoria="setCategoria" />
    </v-card>
  </v-menu>

  <!-- Otros filtros de plataforma, proveedor, etc. (igual que antes) -->
</template>
  
  <script>
import ProductoFiltroCategoria from "@/components/producto/filtros/producto.filtro.categoria.vue";

export default {
  components: {
    ProductoFiltroCategoria,
  },
  data() {
    return {
      selectedCategoria: null,
    };
  },
  watch: {
    "$route.query.categoria": {
      handler: function (newCategoria) {
        this.selectedCategoria = newCategoria;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // Actualizar la query cuando se cambia la categoría
    setCategoria(value) {
      console.log(value);

      this.selectedCategoria = value.name;
      this.updateQuery("categoria", value.name);
    },

    // Actualizar la query
    updateQuery(key, value) {
      const query = { ...this.$route.query, [key]: value };
      console.log(query);
      this.$router.replace({ query });
    },

    // Remover el filtro de la query
    removeCategoria() {
      this.selectedCategoria = null;
      this.removeQuery("categoria");
    },

    // Remover el filtro de la query
    removeQuery(key) {
      const query = { ...this.$route.query };
      delete query[key];
      this.$router.replace({ query });
    },
  },
};
</script>
  
  <style scoped>
/* Estilos para los filtros, puedes adaptarlos como necesites */
</style>
  